"use client";
import { FC } from "react";

import getYouTubeID from "get-youtube-id";

import dynamic from "next/dynamic";

const LiteYouTubeEmbed = dynamic(() => import("react-lite-youtube-embed"));
interface CaseVideoProps {
  title: string;
  url: string;
}
const CaseVideo: FC<CaseVideoProps> = ({ title, url }) => {
  return <LiteYouTubeEmbed id={getYouTubeID(url) as string} title={title} />;
};

export default CaseVideo;
